import { Component } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { DatabaseUserAttribute } from 'src/modules/database/shared/database-user-attribute.model';
import { DatabaseUser } from 'src/modules/database/shared/database-user.entity';
import { RestEndpoint } from 'src/modules/sm-base/models/rest-endpoint.model';
import { FrontendFieldDefinition } from 'src/modules/sm-base/models/frontend-field-definition.model';
import { FrontendFieldType } from 'src/modules/sm-base/models/frontend-field-type.enum';
import { FrontendFormDefinition } from 'src/modules/sm-base/models/frontend-form-definition.model';
import { Utils } from 'src/modules/utils/shared/utils';
import { ObjectOfSimpleDataTypes } from 'src/modules/utils/shared/object-of-simple-data-types.model';
import { DatabaseUserGroup } from 'src/modules/database/shared/database-user-group.model';
import { FrontendFieldListItem } from '../../models/frontend-field-list-item.model';
import { MainFrontendConfigFieldAccess } from 'src/modules/app-template/models/main-frontend-config-field-access.enum';

@Component({
    selector: 'app-edit-general-user',
    templateUrl: './edit-general-user.component.html',
    styleUrls: ['./edit-general-user.component.scss']
    })
export class EditGeneralUserComponent extends ComponentView {

    neededParams: ObjectOfSimpleDataTypes = { id: "number" };
    id: number;

    item: DatabaseUser;
    userGroups: DatabaseUserGroup[];
    form: FrontendFormDefinition;
    
    private applyFieldAccess(field: FrontendFieldDefinition): FrontendFieldDefinition {
        let fa = this.app.mainConfig.adminUsersFieldAccess;
        if (fa == null) {
            return field;
        }
        if (Utils.getSafe(fa, field.id, MainFrontendConfigFieldAccess.editable) == MainFrontendConfigFieldAccess.hidden) {
            return null;
        }
        if (Utils.getSafe(fa, field.id, MainFrontendConfigFieldAccess.editable) == MainFrontendConfigFieldAccess.readOnly) {
            field.enabled = false;
        }
        return field;
    }

    async initParams(): Promise<boolean> {
        this.item = this.id == 0 ? new DatabaseUser() : await this.app.loadDataHandler(async () => RestEndpoint.main().findById(this.id).run("api/app/user").get(DatabaseUser), this);
        this.userGroups = await this.app.loadDataHandler(async () => RestEndpoint.main().run("api/app/usergroup").list(DatabaseUserGroup), this);

        this.form = new FrontendFormDefinition([
            this.applyFieldAccess(new FrontendFieldDefinition("userName", "Benutzername", FrontendFieldType.text)),
            this.applyFieldAccess(new FrontendFieldDefinition("firstName", "Vorname", FrontendFieldType.text)),
            this.applyFieldAccess(new FrontendFieldDefinition("lastName", "Nachname", FrontendFieldType.text)),
            this.applyFieldAccess(new FrontendFieldDefinition("mail", "E-Mail", FrontendFieldType.text)),
            this.applyFieldAccess(new FrontendFieldDefinition("phone", "Telefon", FrontendFieldType.text)),
            this.applyFieldAccess(new FrontendFieldDefinition("isAdmin", "Ist Administrator", FrontendFieldType.checkBox)),
            this.app.mainConfig.useAdminUserGroups ? new FrontendFieldDefinition("groups", "Gruppenzugehörigkeit", FrontendFieldType.comboBoxMulti, { 
                dropdownEditable: true, 
                listItems: FrontendFieldListItem.make(this.userGroups, ug => [ug.id, ug.name], true)
            }) : null,
            this.applyFieldAccess(new FrontendFieldDefinition("password", this.id > 0 ? "Passwort (eintippen für PW-Wechsel)" : "Passwort", FrontendFieldType.password, { mandatory: !(this.id > 0) })),
            ...this.app.mainConfig.additionalUserAttributes.map(a => {
                let result = Utils.cloneDeep(a);
                result.id = "attrib_" + result.id;
                return result;
            })
        ]);

        //HACK für automatische Zuordnung
        (this.item as any).groups = this.item.groups.map(g => g.id);
        this.form.fill(this.item);
        for (let attrib of this.app.mainConfig.additionalUserAttributes) {
            let a = this.item.attributes.find(a2 => a2.key == attrib.id);
            if (a != null) {
                let field = this.form.getField("attrib_" + attrib.id);
                let v = field.type == FrontendFieldType.checkBox ? Utils.toBool(a.value) : a.value;
                field.setValue(v);
            }
        }
        this.app.updateNavigation(null, [
            { label: "Administration", routerLink: ["/base2", "admin"] },
            { label: "Benutzer", routerLink: ["/base2", "admin", "editGeneralUsers"] },
            { label: this.item.getStringRepresentation(), routerLink: ["/base2", "admin", "editGeneralUser", this.id] }
        ]);
        return true;
    }

    async save(): Promise<void> {
        if (!this.app.validateForm(this.form)) {
            return;
        }

        this.form.get(this.item);
        this.item.groups = ((this.item as any).groups as number[]).map(id => this.userGroups.find(ug => ug.id == id));

        if (!Utils.isNoe((this.item as any).password)) {
            if (this.id > 0 && !await this.app.messageDialog.yesNo("Soll das Passwort des Benutzers geändert werden?", "Warnung")) {
                return;
            }
            (this.item as any).attrib____passwordChange = (this.item as any).password;
        }

        for (let attrib of [...this.app.mainConfig.additionalUserAttributes, new FrontendFieldDefinition("___passwordChange", "", FrontendFieldType.text)]) {
            if (Utils.hasProperty(this.item, "attrib_" + attrib.id)) {
                let a = this.item.attributes.find(a2 => a2.key == attrib.id);
                if (a == null) {
                    a = Utils.fromPlain(DatabaseUserAttribute, {
                        key: attrib.id
                    });
                    this.item.attributes.push(a);
                }
                a.value = this.item["attrib_" + attrib.id];
                delete this.item["attrib_" + attrib.id];
            }
        }

        if ((await this.app.saveDataHandler(async () => RestEndpoint.main().upsert(this.item).run("api/app/user").getText(), this, true, true))[0]) {
            this.app.auth.updateUserDetails();
        }
    }

}
